const removeExtraSpaces = (str = '') => str.replace(/\s+/g, ' ').trim();

const richTextToArr = (str = '') => str.split(/\r\n|\n|\r/);

export { removeExtraSpaces, richTextToArr };
